<mat-card appearance="outlined" class="popup-root">
  <mat-card-content class="popup-content">
    <!-- TYPE 2 : COUPON / SAVED POPUP -->
    @if (dialogData?.type === 2) {
      <div class="coupon-card">
        <button class="close-btn" aria-label="Close" (click)="onClose()">
          <mat-icon>close</mat-icon>
        </button>
        <div class="coupon-icon-wrap">
          <div class="coupon-bag">
            <mat-icon class="bag-icon">shopping_bag</mat-icon>
            <div class="badge">
              <mat-icon class="badge-icon">check</mat-icon>
            </div>
          </div>
        </div>
        <div class="coupon-top-badge">
          <span>{{ dialogData?.topText || 'Coupon Applied 🎉' }}</span>
        </div>
        <h2 class="coupon-title">
          <span class="amount">₹{{ dialogData?.savedAmount || 0 }}</span> saved with
          <br />
          <span class="highlight">
            {{
              dialogData?.couponCode
                ? "'" + dialogData.couponCode + "'"
                : (dialogData?.highlightText || 'Coupon Applied')
            }}
          </span>
        </h2>
        @if (dialogData?.description) {
          <p class="coupon-desc-sub">
            {{ dialogData.description }}
          </p>
        }
        <button class="cta-btn" (click)="onClose()">
          {{ dialogData?.ctaText || 'YAY!' }}
        </button>
        <div class="bottom-bar"></div>
      </div>
    } @else {
      <!-- TYPE 1 : CONFIRMATION / ALERT POPUP -->
      <div class="confirm-card">
        <button class="close-btn" aria-label="Close" (click)="onNo()">
          <mat-icon>close</mat-icon>
        </button>

        <div class="confirm-icon-wrap" [ngClass]="'theme-' + iconTheme">
          <mat-icon>{{ iconName }}</mat-icon>
        </div>

        <h3 class="confirm-title">{{ heading }}</h3>

        @if (message) {
          <p class="confirm-desc">{{ message }}</p>
        }

        <div class="confirm-actions">
          <button type="button" class="btn-secondary" (click)="onNo()">
            {{ cancelLabel }}
          </button>
          <button type="button" class="btn-primary" [ngClass]="'theme-' + iconTheme" (click)="onYes()">
            {{ confirmLabel }}
          </button>
        </div>
      </div>
    }
  </mat-card-content>
</mat-card>
